import { App, UniversalAppState } from "@pimo/pimo-app-builder";
import { DefaultOverlayPartialAppState } from "@pimo/pimo-components";

export function showSnackbar(
  app: App<UniversalAppState & DefaultOverlayPartialAppState>,
  message: string,
  severity: "info" | "success" | "warning" | "error" = "success"
) {
  app.patchAppState({
    snackbar: {
      message,
      severity,
      open: true,
      type: "snackbar",
    },
  });
}
